var $beddb5ded972a868$exports = {};
$beddb5ded972a868$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "placeholder": `\u{C120}\u{D0DD}\u{2026}`
};


export {$beddb5ded972a868$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
